<div class="ds-board-filter d-flex align-items-center gap-2">
  @for (filter of dropdownFilters(); track filter.key) {
    @if (filter.mode === 'api') {
      <ng-select
        class="ds-board-filter__control form-control"
        [multiple]="true"
        [dwApiSelect]="filter.apiSelect!"
        [config]="apiSelectConfig"
        [bindLabel]="filter.bindLabel"
        bindValue="id"
        [placeholder]="labelKey[filter.key] | abpLocalization"
        [ngModel]="selectionOf(filter.key)"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="setSelection(filter.key, $event)"
      />
    } @else {
      <ng-select
        class="ds-board-filter__control form-control"
        [multiple]="true"
        [items]="filter.options ?? []"
        [bindLabel]="filter.bindLabel"
        bindValue="id"
        [placeholder]="labelKey[filter.key] | abpLocalization"
        [ngModel]="selectionOf(filter.key)"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="setSelection(filter.key, $event)"
      />
    }
  }

  @for (key of textFilters(); track key) {
    <input
      type="search"
      class="ds-board-filter__control form-control"
      [placeholder]="labelKey[key] | abpLocalization"
      [ngModel]="textOf(key)"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="setText(key, $event)"
    />
  }
</div>
